import React, { useState, useRef, useEffect } from 'react'
import '../../../styles/MenuPrincipal.css'
import { Link as LinkScroll } from 'react-scroll'
import { Link as LinkRouter } from 'react-router-dom'

function MenuPrincipal() {
  const menuPRef = useRef(null)
  const [openSousMenu, setOpenSousMenu] = useState(null)

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuPRef.current && !menuPRef.current.contains(event.target)) {
        setOpenSousMenu(null)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    document.addEventListener('touchstart', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('touchstart', handleClickOutside)
    }
  }, [])

  const toggleSousMenu = (id) => {
    setOpenSousMenu((prev) => (prev === id ? null : id))
  }

  return (
    <nav id="MenuP" className="menuPrincipal" ref={menuPRef}>
      <LinkScroll
        to="Accueil"
        smooth={true}
        duration={1000}
        className="menuItem menuItemLink"
        onClick={() => setOpenSousMenu(null)}
        onMouseEnter={(e) => e.currentTarget.classList.add('menuItemHover')}
        onMouseLeave={(e) => e.currentTarget.classList.remove('menuItemHover')}
      >
        Accueil
      </LinkScroll>

      <div
        className="menuItem"
        title="Cours"
        onClick={() => toggleSousMenu('cours')}
        onMouseEnter={(e) => e.currentTarget.classList.add('menuItemHover')}
        onMouseLeave={(e) => e.currentTarget.classList.remove('menuItemHover')}
      >
        <span>Cours</span>
        <svg
          viewBox="0 0 1030 638"
          width="10"
          className={`arrowIcon ${openSousMenu === 'cours' ? 'arrowIconOpen' : ''}`}
        >
          <path
            d="M1017 68L541 626q-11 12-26 12t-26-12L13 68Q-3 49 6 24.5T39 0h952q24 0 33 24.5t-7 43.5z"
            fill="#FFF"
          />
        </svg>
        <div
          className={`sousMenu ${openSousMenu === 'cours' ? 'sousMenuVisible' : 'sousMenuHidden'}`}
        >
          <LinkScroll
            to="Professeurs"
            smooth={true}
            duration={1000}
            className="sousMenuItem sousMenuItemLink"
            onClick={() => setOpenSousMenu(null)}
            onMouseEnter={(e) =>
              e.currentTarget.classList.add('sousMenuItemHover')
            }
            onMouseLeave={(e) =>
              e.currentTarget.classList.remove('sousMenuItemHover')
            }
          >
            Professeurs
          </LinkScroll>
          <LinkScroll
            to="HorairesTarifs"
            smooth={true}
            duration={1000}
            className="sousMenuItem sousMenuItemLink"
            onClick={() => setOpenSousMenu(null)}
            onMouseEnter={(e) =>
              e.currentTarget.classList.add('sousMenuItemHover')
            }
            onMouseLeave={(e) =>
              e.currentTarget.classList.remove('sousMenuItemHover')
            }
          >
            Horaires
          </LinkScroll>
          <LinkScroll
            to="HorairesTarifs"
            smooth={true}
            duration={1000}
            className="sousMenuItem sousMenuItemLink"
            onClick={() => setOpenSousMenu(null)}
            onMouseEnter={(e) =>
              e.currentTarget.classList.add('sousMenuItemHover')
            }
            onMouseLeave={(e) =>
              e.currentTarget.classList.remove('sousMenuItemHover')
            }
          >
            Tarifs
          </LinkScroll>
        </div>
      </div>

      <div
        className="menuItem"
        title="Inscription"
        onClick={() => toggleSousMenu('inscription')}
        onMouseEnter={(e) => e.currentTarget.classList.add('menuItemHover')}
        onMouseLeave={(e) => e.currentTarget.classList.remove('menuItemHover')}
      >
        <span>Inscription</span>
        <svg
          viewBox="0 0 1030 638"
          width="10"
          className={`arrowIcon ${openSousMenu === 'inscription' ? 'arrowIconOpen' : ''}`}
        >
          <path
            d="M1017 68L541 626q-11 12-26 12t-26-12L13 68Q-3 49 6 24.5T39 0h952q24 0 33 24.5t-7 43.5z"
            fill="#FFF"
          />
        </svg>
        <div
          className={`sousMenu ${openSousMenu === 'inscription' ? 'sousMenuVisible' : 'sousMenuHidden'}`}
        >
          <a
            href={`${process.env.PUBLIC_URL}/PDF/Bulletin d'inscriptionWeb2025-2026.pdf`}
            target="_blank"
            rel="noreferrer"
            className="sousMenuItem sousMenuItemLink"
            onMouseEnter={(e) =>
              e.currentTarget.classList.add('sousMenuItemHover')
            }
            onMouseLeave={(e) =>
              e.currentTarget.classList.remove('sousMenuItemHover')
            }
          >
            Bulletin
          </a>
        </div>
      </div>

      <LinkScroll
        to="Evenements"
        smooth={true}
        duration={1000}
        className="menuItem menuItemLink"
        onClick={() => setOpenSousMenu(null)}
        onMouseEnter={(e) => e.currentTarget.classList.add('menuItemHover')}
        onMouseLeave={(e) => e.currentTarget.classList.remove('menuItemHover')}
      >
        Evènements
      </LinkScroll>

      <div
        className="menuItem"
        title="Médias"
        onClick={() => toggleSousMenu('medias')}
        onMouseEnter={(e) => e.currentTarget.classList.add('menuItemHover')}
        onMouseLeave={(e) => e.currentTarget.classList.remove('menuItemHover')}
      >
        <span>Médias</span>
        <svg
          viewBox="0 0 1030 638"
          width="10"
          className={`arrowIcon ${openSousMenu === 'medias' ? 'arrowIconOpen' : ''}`}
        >
          <path
            d="M1017 68L541 626q-11 12-26 12t-26-12L13 68Q-3 49 6 24.5T39 0h952q24 0 33 24.5t-7 43.5z"
            fill="#FFF"
          />
        </svg>
        <div
          className={`sousMenu ${openSousMenu === 'medias' ? 'sousMenuVisible' : 'sousMenuHidden'}`}
        >
          <LinkRouter
            to="/PhotosPage"
            className="sousMenuItem sousMenuItemLink"
            onMouseEnter={(e) =>
              e.currentTarget.classList.add('sousMenuItemHover')
            }
            onMouseLeave={(e) =>
              e.currentTarget.classList.remove('sousMenuItemHover')
            }
          >
            Photos
          </LinkRouter>
          <LinkRouter
            to="/Videos"
            className="sousMenuItem sousMenuItemLink"
            onMouseEnter={(e) =>
              e.currentTarget.classList.add('sousMenuItemHover')
            }
            onMouseLeave={(e) =>
              e.currentTarget.classList.remove('sousMenuItemHover')
            }
          >
            Videos
          </LinkRouter>
        </div>
      </div>

      <LinkScroll
        to="Contacts"
        smooth={true}
        duration={1000}
        className="menuItem menuItemLink"
        onClick={() => setOpenSousMenu(null)}
        onMouseEnter={(e) => e.currentTarget.classList.add('menuItemHover')}
        onMouseLeave={(e) => e.currentTarget.classList.remove('menuItemHover')}
      >
        Contacts
      </LinkScroll>
    </nav>
  )
}

export default MenuPrincipal
